import type { ReactNode } from 'react';
import { useT } from '../../i18n';
import './summary.css';

export interface SummaryProps {
  /** "BCN → LHR · VY6650" */
  line: ReactNode;
  /** "8 Sep 2026 · via FRA" */
  meta?: ReactNode;
  onEdit?: () => void;
  /** Accessible label for the edit button, e.g. "Edit route". Visible text is "Edit". */
  editLabel?: string;
}

/** The route/date/flight card with an edit link, on every screen after S3 (design rule 8). */
export function Summary({ line, meta, onEdit, editLabel }: SummaryProps) {
  const t = useT();
  return (
    <div className="summary">
      <span>
        <span className="summary__line">{line}</span>
        {meta && <span className="summary__meta">{meta}</span>}
      </span>
      {onEdit && (
        <button type="button" className="summary__edit" onClick={onEdit} aria-label={editLabel}>
          {t('common.edit')}
        </button>
      )}
    </div>
  );
}
